import Hook from "./useCard";
import qbo_logo from "../../../assets/qbo_logo.svg";
import { PrimaryButton } from "@moneris-portal/button";

const QBO_Card = () => {
  const { translate, lang, history } = Hook.useCard();
  return (
    <div className="application_card_container">
      <div className="application_card_body">
        <div className={`cardIcon`}>
          <img src={qbo_logo} alt="Quickbooks logo" />
        </div>
        <div className="card_desc">
          <div className="cardTitle">
            <span>{translate("card-title")}</span>
          </div>
          <div className="cardSubtitle">{translate("card-description-bold")}</div>
          <div className="cardDescription">
            {translate("card-description")}
            <a
              href={translate("card-footnote-link")}
              target="_blank"
              rel="noopener noreferrer"
            >
              <sup>1</sup>
            </a>
          </div>
          <div className="_card_buttons">
            <PrimaryButton
              title={translate("card-button")}
              clickHandler={() => history.push(`/${lang}/qbo-accounting`)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QBO_Card;

